<template src="./FeedbackPreview.html"></template>

<script>
import {
  isAnswered,
  answeredCount,
  isSubjectComplete,
  formatAnswer,
} from "../utils/responses";
import { initialsOf } from "../utils/faculty";

export default {
  name: "FeedbackPreview",

  props: {
    formTitle: { type: String, default: "" },
    isCourseFeedback: { type: Boolean, default: false },
    subjects: { type: Array, default: () => [] },
    questions: { type: Array, default: () => [] },
    submitting: { type: Boolean, default: false },
  },

  data: () => ({
    declared: false,
    // Subject ids whose answers are expanded — empty so all start collapsed.
    expanded: [],
  }),

  computed: {
    allQuestions() {
      return this.isCourseFeedback
        ? this.subjects.reduce((all, s) => all.concat(s.questions), [])
        : this.questions;
    },

    total() {
      return this.allQuestions.length;
    },

    answered() {
      return answeredCount(this.allQuestions);
    },

    remaining() {
      return this.total - this.answered;
    },

    progress() {
      return this.total ? Math.round((this.answered / this.total) * 100) : 0;
    },

    completeSubjects() {
      return this.subjects.filter(isSubjectComplete).length;
    },

    canSubmit() {
      return this.remaining === 0 && this.declared;
    },

    hint() {
      const parts = [];
      if (this.remaining > 0) {
        parts.push(`${this.remaining} question${this.remaining === 1 ? "" : "s"} remaining`);
      }
      return parts.join(" · ");
    },
  },

  methods: {
    isAnswered,
    formatAnswer,

    isComplete(subject) {
      return isSubjectComplete(subject);
    },

    count(subject) {
      return answeredCount(subject.questions);
    },

    // The subject, not its faculty — no faculty detail is shown on this screen.
    initials(subject) {
      return initialsOf(subject.subjectName || subject.subjectCode || "");
    },

    isExpanded(subjectId) {
      return this.expanded.indexOf(subjectId) !== -1;
    },

    toggleSubject(subjectId) {
      const index = this.expanded.indexOf(subjectId);
      if (index === -1) this.expanded.push(subjectId);
      else this.expanded.splice(index, 1);
    },
  },
};
</script>

<style src="./FeedbackPreview.css" scoped></style>
